import { countryOptions } from 'components/helper/countryPhoneCode';
import DatePickerInput from 'components/input/DatePicker';
import SelectInput from 'components/input/SelectInput';
import YesNoSwitch from 'components/input/YesNoSwitch';
import TextInput from 'components/input/textInput';
import React from 'react';
import Grid from '@mui/joy/Grid';
import collegeServices from 'services/collegeServices';

interface Props {
  formik: any;
  check?: any;
  isMobile?: boolean;
  disabled?: boolean;
}

const BirthPalace = (props: Props) => {
  const { check, 
    //isMobile = false, 
    disabled = false } = props;
  const [stateOptions, setStateOptions] = React.useState<any[]>([]);

  React.useEffect(() => {
    collegeServices.getState().then((res: any) => {
      const states = res.map((item: any) => {
        return item.descr;
      });
      setStateOptions(states);
    });
    return () => {
      setStateOptions([]);
    };
  }, []);

  // Helper function to render grid items dynamically
  const renderGridItem = (children: React.ReactNode, size: { xs?: number; md?: number } = { xs: 12, md: 6 }) => (
    <Grid xs={size.xs || 12} md={size.md || 6}>
      {children}
    </Grid>
  );

  // Create array of visible fields based on conditions
  const getVisibleFields = () => {
    const fields: React.ReactNode[] = [];

    // Always visible fields
    fields.push(
      renderGridItem(
        <SelectInput
          form={props.formik}
          option={countryOptions}
          name="country_birthplace"
          values={props.formik.values.country_birthplace}
          onChange={props.formik.handleChange}
          label="Country / Region / Territory*"
          isMissing={!props.formik.values.country_birthplace && check}
          disabled={disabled}
        />
      )
    );

    fields.push(
      renderGridItem(
        <TextInput
          name="city_birthplace"
          values={props.formik.values.city_birthplace}
          onChange={props.formik.handleChange}
          label="City of birth*"
          countText={20}
          isMissing={!props.formik.values.city_birthplace && check}
          disabled={disabled}
        />
      )
    );

    // Conditional fields for United States
    if (props.formik.values.country_birthplace === 'United States of America') {
      fields.push(
        renderGridItem(
          <SelectInput
            logo="span-cm-logo"
            className="common-flag"
            name="number_of_year_in_us"
            values={props.formik.values.number_of_year_in_us}
            isMissing={!props.formik.values.number_of_year_in_us && check}
            onChange={props.formik.handleChange}
            label="Number of years you have lived in the United States*"
            option={[
              '0',
              '< 1 years',
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
              '16',
              '17',
              '18',
              '19',
              '20',
              '> 20 years',
            ]}
            disabled={disabled}
          />
        )
      );

      fields.push(
        renderGridItem(
          <SelectInput
            option={stateOptions}
            name="state_birthplace"
            values={props.formik.values.state_birthplace}
            onChange={props.formik.handleChange}
            label="State of birth *"
            isMissing={!props.formik.values.state_birthplace && check}
            disabled={disabled}
          />
        )
      );

      // California specific fields
      if (props.formik.values.state_birthplace === 'California') {
        fields.push(
          renderGridItem(
            <YesNoSwitch
              name="statement_legal_resident.have_lived_in_California_continuously_since_birth"
              values={
                props.formik.values.statement_legal_resident
                  ?.have_lived_in_California_continuously_since_birth
              }
              onChange={props.formik.handleChange}
              label="Have you lived in California continuously since birth?*"
              isMissing={
                !props.formik.values.statement_legal_resident
                  ?.have_lived_in_California_continuously_since_birth && check
              }
              disabled={disabled}
            />
          )
        );

        if (props.formik.values.statement_legal_resident?.have_lived_in_California_continuously_since_birth !== 'true') {
          fields.push(
            renderGridItem(
              <DatePickerInput
                name="statement_legal_resident.when_your_present_stay_in_California_begin"
                values={
                  props.formik.values.statement_legal_resident
                    ?.when_your_present_stay_in_California_begin
                }
                onChange={(value) =>
                  props.formik.setFieldValue(
                    'statement_legal_resident.when_your_present_stay_in_California_begin',
                    value
                  )
                }
                label="When did your present stay in California begin?*"
                isMissing={
                  !props.formik.values.statement_legal_resident
                    ?.when_your_present_stay_in_California_begin && check
                }
                disabled={disabled}
              />
            )
          );
        }
      }
    } else {
      // Fields for non-US countries
      fields.push(
        renderGridItem(
          <div className="text-field-light">Years inside and outside the United States</div>,
          { xs: 12, md: 12 }
        )
      );

      fields.push(
        renderGridItem(
          <TextInput
            logo="span-csu-logo"
            name="csu_info.year_move_to_us"
            label="If you were born outside of the U.S., what year did you or will you move to the U.S."
            isMissing={!props.formik.values.csu_info?.year_move_to_us && check}
            onChange={props.formik.handleChange}
            values={props.formik.values.csu_info?.year_move_to_us}
            disabled={disabled}
          />,
          { xs: 12, md: 12 }
        )
      );

      fields.push(
        renderGridItem(
          <SelectInput
            logo="span-cm-logo"
            option={[
              '0',
              '< 1 years',
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
              '16',
              '17',
              '18',
              '19',
              '20',
              '> 20 years',
            ]}
            className="common-flag end-flag"
            name="number_of_year_in_us"
            values={props.formik.values.number_of_year_in_us}
            onChange={props.formik.handleChange}
            label="Number of years you have lived in the United States*"
            isMissing={!props.formik.values.number_of_year_in_us && check}
          />
        )
      );

      fields.push(
        renderGridItem(
          <SelectInput
            option={[
              '0',
              '< 1 years',
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
              '16',
              '17',
              '18',
              '19',
              '20',
              '> 20 years',
            ]}
            className="common-flag end-flag"
            name="number_of_year_outside_us"
            values={props.formik.values.number_of_year_outside_us}
            onChange={props.formik.handleChange}
            label="Number of years you have lived outside the United States*"
            isMissing={!props.formik.values.number_of_year_outside_us && check}
            disabled={disabled}
          />
        )
      );
    }

    return fields;
  };

  return (
    <Grid container spacing={2} className="gm-form-fields">
      <Grid xs={12}>
        <div className="fs-5 py-1">Birthplace</div>
      </Grid>
      {getVisibleFields()}
    </Grid>
  );
};

export default BirthPalace;
